import { ArticleBodyWrapper } from './ArticleBodyWrapper.tsx';

export function ArticleTitle({ title }: { title: string }) {
  return (
    <ArticleBodyWrapper>
      <h1>{title}</h1>
    </ArticleBodyWrapper>
  );
}
